import { styled, alpha, Typography } from '@mui/material';

import { AstroAvailabilityStatus } from '@/generated/gql/graphql';

export const Root = styled('li')(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
}));

export const ReferenceTag = styled(Typography)(({ theme }) => ({
  background: alpha(theme.palette.text.primary, 0.12),
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
}));

enum AvailabilityColorType {
  success = 'success',
  error = 'error',
  warning = 'warning',
}

const colorMap: Record<AstroAvailabilityStatus, AvailabilityColorType> = {
  [AstroAvailabilityStatus.LOW]: AvailabilityColorType.error,
  [AstroAvailabilityStatus.MEDIUM]: AvailabilityColorType.warning,
  [AstroAvailabilityStatus.HIGH]: AvailabilityColorType.success,
};

export const AvailabilityBadge = styled('div')<{
  availabilityStatus: AstroAvailabilityStatus;
}>(({ availabilityStatus, theme }) => ({
  '&::after': {
    position: 'absolute',
    height: '12px',
    width: '12px',
    background: theme.palette[colorMap[availabilityStatus]].main,
    content: '""',
    bottom: 0,
    right: 0,
    borderRadius: '6px',
  },
}));

export const OptionText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
}));
